import { getRefundsCollectionRef } from "../../../firebase/collectionReferences";
import { getDocs } from "firebase/firestore";

// Get ALl refunds
export async function getRefunds() {
  let usersRef = getRefundsCollectionRef();

  return (await getDocs(usersRef)).docs.map((row) => ({
    ...row.data(),
    id: row.id,
  }));
}
